import { isDefined } from '@sgme/fp';

import { useTrackEvent } from '@/App/Blotter/useTrackEvent.ts';
import { useAlgoTileId, useValidateAlgo } from '@/App/tiles/orders/AlgoOrders/AlgoContext.tsx';
import { OrderRow } from '@/App/tiles/orders/components/OrderRow.tsx';
import { SgNumberInput } from '@/components/sg-design-system/components/input/SgNumberInput';
import { OmsFieldErrorWrapper } from '@/components/ui/OmsFieldErrorWrapper.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectAlgoClipSize, selectAlgoErrors } from '@/store/orders/algoOrders/selectors.ts';

export const AlgoClipSize = () => {
  const tileId = useAlgoTileId();
  const track = useTrackEvent();

  const clipSize = useAppSelector((state) => selectAlgoClipSize(state, tileId));

  const errors = useAppSelector((state) => selectAlgoErrors(state, tileId));
  const clipSizeError = errors?.clipSize;

  const validateAlgo = useValidateAlgo();

  const handleClipSizeChange = (value: number | undefined) => {
    track('Order action', 'Clip size changed');
    validateAlgo({
      clipSize: value,
    });
  };

  return (
    <OrderRow labelId="order.fields.clipSize">
      <OmsFieldErrorWrapper errors={clipSizeError}>
        <SgNumberInput
          valuePosition="start"
          size="sm"
          data-e2e="clip-size"
          value={clipSize}
          maxDecimals={9}
          onChange={handleClipSizeChange}
          selectAllOnFocus
          state={isDefined(clipSizeError) ? 'invalid' : undefined}
        />
      </OmsFieldErrorWrapper>
    </OrderRow>
  );
};
